import { useParams } from 'react-router';
import { versionFromDocSlug } from './versions';
import { isVisibleVersion, MAX_DOCS_VERSION } from './visible-versions';

/** The real version for the current route, falling back to the max docs version for unknown or hidden versions */
export function useVersion(): string {
  const { version } = useParams();
  const resolved = versionFromDocSlug(version);
  return isVisibleVersion(resolved) ? resolved : MAX_DOCS_VERSION;
}
